module.exports = "/images/co.svg?4f0581c6c238ad949f4ddf8f1fe06b6d";